import { useUIStore } from '@/store/uiStore';
import { scopeLabel } from '@/lib/propuesta-selectors';
import type { PropuestaDetail } from '@/types';
import styles from './ScopeChip.module.css';

interface Props {
  detail: PropuestaDetail;
}

export function ScopeChip({ detail }: Props) {
  const scope = useUIStore((s) => s.scope);
  const clearScope = useUIStore((s) => s.clearScope);
  const info = scopeLabel(detail, scope);

  if (!info) {
    return (
      <div className={styles.wrap}>
        <span className={styles.hint}>
          Sin scope activo — Row 2 muestra todo. Selecciona una EV o Iniciativa arriba.
        </span>
      </div>
    );
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.chip} style={{ borderLeftColor: info.color }}>
        <div>
          <div className={styles.kind}>{info.kind}</div>
          <div className={styles.name}>{info.name}</div>
        </div>
        <button className={styles.clear} onClick={clearScope}>
          Limpiar ✕
        </button>
      </div>
      <span className={styles.hint}>Las vistas de abajo están filtradas por este scope.</span>
    </div>
  );
}
